export type TThematics = {
  id: string;
  title: string;
  url: string;
  img: {
    height: string;
    src: string;
    width: string;
  };
}[];

export type TThematicsResponse = {
  breadcrumb: {
    title: string;
    url: string;
  }[];
  data: TThematics;
};

export type TThematicsGroup = {
  id: string;
  title: string;
  url: string;
  img: {
    height: string;
    src: string;
    width: string;
  };
}[];

export type TThematicsSectionResponse = {
  breadcrumb: {
    title: string;
    url: string;
  }[];
  data: {
    items: TThematics;
    title: string;
  };
  meta: {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
  };
};

export type TThematicsSectionGroupResponse = {
  breadcrumb: {
    title: string;
    url: string;
  }[];
  data: {
    items: TThematics;
    title: string;
    notes: string[];
  };
  meta: {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
  };
};
